class AuthController {
  constructor($state, Auth, $mdToast) {
    this.name = 'auth';
    this.Auth = Auth;
    this.$state = $state;
    this.$mdToast = $mdToast;
  }
  async onSubmit({ credentials, password }) {
    const { $mdToast, Auth, $state } = this;
    try {
      await Auth.signIn({ credentials, password });
      $state.go('main.user');
    } catch (error) {
      $mdToast.show($mdToast.simple().textContent(error.data.message));
      this.user.password = '';
    }
  }
}
AuthController.$inject = ['$state', 'Auth', '$mdToast'];

export default AuthController;



// WEBPACK FOOTER //
// ./client/app/components/auth/auth.controller.js